const initialState = {
  // Remember editor sidebar state
  sidebarOpen: true,
  sidebarTab: 'timeline',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_SIDEBAR_OPEN':
      return {
        ...state,
        sidebarOpen: !!action.payload,
      };

    case 'SET_SIDEBAR_TAB':
      return {
        ...state,
        sidebarTab: action.payload,
      };

    default:
      return state;
  }
}

export function setContractSidebarOpenAction(sidebarOpen) {
  return {
    type: 'SET_SIDEBAR_OPEN',
    payload: sidebarOpen,
  };
}

export function setContractSidebarTabAction(sidebarTab) {
  return {
    type: 'SET_SIDEBAR_TAB',
    payload: sidebarTab,
  };
}
